import { getCache, setCache } from "../Utils/cacheUtil";

export const updateLookup = async <T>(
  key: string,
  fetchFn: () => Promise<T[]>,
  currentUser: string,
  maxCacheAge: number,
): Promise<T[]> => {
  const cachedData = getCache<T[]>(key, currentUser, maxCacheAge);
  if (cachedData && Array.isArray(cachedData) && cachedData.length > 0) {
    //console.log(`[Cache Hit] ${key} - returning ${cachedData.length} cached items`);
    return cachedData;
  }
  //console.log(`[Cache Miss] ${key} - fetching from API...`);
  const fetchedData = await fetchFn();
  //console.log(`[API Response] ${key} - received ${Array.isArray(fetchedData) ? fetchedData.length : 0} items`);
  if (fetchedData && Array.isArray(fetchedData) && fetchedData.length > 0) {
    setCache(key, fetchedData, currentUser);
    //console.log(`[Cache Set] ${key} - cached ${fetchedData.length} items successfully`);
  } else {
    //console.warn(`[Cache Skip] ${key} - not caching empty or invalid data`);
  }
  return fetchedData;
};

export const updateLookupRecord = async <T>(
  key: string,
  fetchFn: () => Promise<Record<string, T[]>>,
  currentUser: string,
  maxCacheAge: number,
): Promise<Record<string, T[]>> => {
  const cachedData = getCache<Record<string, T[]>>(
    key,
    currentUser,
    maxCacheAge,
  );
  if (
    cachedData &&
    typeof cachedData === "object" &&
    Object.keys(cachedData).length > 0
  ) {
    // console.log(
    //   `[Cache Hit] ${key} - returning cached data with ${Object.keys(cachedData).length} keys`,
    // );
    return cachedData;
  }
  //console.log(`[Cache Miss] ${key} - fetching from API...`);
  const fetchedData = await fetchFn();
  // console.log(
  //   `[API Response] ${key} - received data with ${Object.keys(fetchedData || {}).length} keys`,
  //   fetchedData,
  // );
  if (
    fetchedData &&
    typeof fetchedData === "object" &&
    Object.keys(fetchedData).length > 0
  ) {
    setCache(key, fetchedData, currentUser);
    //console.log(`[Cache Set] ${key} - cached data successfully`);
  } else {
    //console.warn(`[Cache Skip] ${key} - not caching empty or invalid data`);
  }
  return fetchedData || {};
};
